var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSample = function SvgSample(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22.914 4.742 11.08 7.497a1.783 1.783 0 0 1 0 2.94l-11.08 7.497a4.299 4.299 0 0 1-4.828 0l-11.08-7.497a1.783 1.783 0 0 1 0-2.94l11.08-7.497a4.299 4.299 0 0 1 4.828 0Zm11.556 15.49c-.258.419-.6.779-1.004 1.055l-10.531 7.215a4.299 4.299 0 0 1-4.87 0L7.534 21.287c-1.325-.907-1.838-2.578-1.356-4.045l11.908 8.056c1.37.927 3.13.985 4.549.174l.279-.174L34.82 17.24c.316.965.222 2.06-.35 2.99Zm0 5.741c-.258.42-.6.78-1.004 1.056l-10.531 7.215a4.299 4.299 0 0 1-4.87 0L7.534 27.03c-1.325-.907-1.838-2.578-1.356-4.045l11.908 8.056c1.37.927 3.13.985 4.549.174l.279-.174 11.907-8.057c.316.965.222 2.06-.35 2.99Z",
    fill: "#666"
  })));
};
export default SvgSample;